import { MatchType, PlayerGrouping } from '@nova/types';

import { assetLobbyThumbOutpostRun } from './asset-bundle-names';

export const mapConfigOrLiteral = [
  {
    type: MatchType.outpostRuns,
    id: 'level-tutorial',
    assetName: 'level-tutorial',
    name: 'loc:::map_config_tutorial',
    teamCount: 1,
    teamSize: 1,
    playerGrouping: PlayerGrouping.SP,
    isAvailable: true,
    lobbyConfig: {
      title: 'loc:::game_list_outpostrun_name',
      subtitle: 'loc:::map_config_tutorial',
      dataKey: assetLobbyThumbOutpostRun
    }
  },
  {
    type: MatchType.outpostRuns,
    id: 'level-1',
    assetName: 'level-1',
    name: 'loc:::map_config_outpost_run_1_name',
    unlockedByMapId: 'level-tutorial',
    teamCount: 1,
    teamSize: 1,
    playerGrouping: PlayerGrouping.SP,
    isAvailable: true,
    lobbyConfig: {
      title: 'loc:::game_list_outpostrun_name',
      subtitle: 'loc:::map_config_or_level_1_name',
      dataKey: assetLobbyThumbOutpostRun,
      unlockTooltip: 'loc:::completeTutorialToUnlock'
    }
  },
  {
    type: MatchType.outpostRuns,
    id: 'level-2',
    assetName: 'level-2',
    name: 'loc:::map_config_outpost_run_2_name',
    unlockedByMapId: 'level-1',
    teamCount: 1,
    teamSize: 1,
    playerGrouping: PlayerGrouping.SP,
    isAvailable: true,
    lobbyConfig: {
      title: 'loc:::game_list_outpostrun_name',
      subtitle: 'loc:::map_config_or_level_2_name',
      dataKey: assetLobbyThumbOutpostRun,
      unlockTooltip: 'loc:::completeLevel1ToUnlock'
    }
  },
  {
    type: MatchType.outpostRuns,
    id: 'level-3',
    assetName: 'level-3',
    name: 'loc:::map_config_outpost_run_3_name',
    unlockedByMapId: 'level-2',
    teamCount: 1,
    teamSize: 1,
    playerGrouping: PlayerGrouping.SP,
    isAvailable: true,
    lobbyConfig: {
      title: 'loc:::game_list_outpostrun_name',
      subtitle: 'loc:::map_config_or_level_3_name',
      dataKey: assetLobbyThumbOutpostRun,
      unlockTooltip: 'loc:::completeLevel2ToUnlock'
    }
  }
] as const;
